import { render, staticRenderFns } from "./AddAuth.vue?vue&type=template&id=43c223c4&scoped=true"
import script from "./AddAuth.vue?vue&type=script&lang=js"
export * from "./AddAuth.vue?vue&type=script&lang=js"
import style0 from "./AddAuth.vue?vue&type=style&index=0&id=43c223c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c223c4",
  null
  
)

export default component.exports